<template>
    <div class="main-body">
        <cabecalho-padrao/>
    
        <section class="sub-menu-body">
            <sub-menu/>
            <div class="main">

            </div>
        </section>

    </div>
</template>

<script>
import CabecalhoPadrao from '../components/Cabecalho.vue';
import subMenuMais from '../components/subMenuMais.vue';
export default {
  name: 'Mais',
  components:{
    'cabecalho-padrao': CabecalhoPadrao,
    'sub-menu': subMenuMais
  },
  data: () => ({

  })
}
</script>

<style>
  @import '../css/components/sub-menu-body.css';
</style>